import { useReportTranslation } from '../../../hooks';
import { SidebarModal } from '../SidebarModal';
import { About } from './views';

const InfoModal = ({ close }: { close: () => void }) => {
  const { t } = useReportTranslation();
  const sidebar = [{ id: 'about', label: t('reports_info_about') }];
  const views = [{ id: 'about', view: <About /> }];
  return <SidebarModal sidebar={sidebar} views={views} close={close} />;
};

export default InfoModal;
